























import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IMenuRoute } from "@/models/routes";

@Component
export default class PromotionsListView extends Vue {
  // Props

  @Prop({ default: () => () => [] })
  public routes!: () => IMenuRoute[];

  // Methods

  public addPromotion() {
    if (!this.canCreatePromotion) return;

    this.$router.push({
      name: "admin__addPromotion"
    });
  }

  // Computed

  public get canCreatePromotion() {
    return this.$userCan("create_promotion");
  }

  public get cta() {
    return this.canCreatePromotion ? this.$t("_.add_promotion") : "";
  }
}
